export const CLEAR_NOTIF = "CLEAR_NOTIF";
export const ADD_NOTIF = "ADD_NOTIF";
export const DELETE_NOTIF = "DELETE_NOTIF";
